/**
 * UTF-8 safe base64 encoding/decoding utilities.
 *
 * The native btoa() and atob() functions only work with Latin1 characters.
 * These functions handle UTF-8 strings properly by first encoding/decoding as UTF-8 bytes.
 */

/**
 * Encodes a UTF-8 string to base64, safely handling multi-byte characters like Japanese text.
 * This is a UTF-8 safe replacement for btoa().
 */
export function utf8ToBase64(str: string): string {
  const encoder = new TextEncoder()
  const bytes = encoder.encode(str)

  // Convert bytes to binary string for btoa
  let binary = ''
  for (const byte of bytes) {
    binary += String.fromCharCode(byte)
  }

  return btoa(binary)
}

/**
 * Decodes a base64 string back to UTF-8, safely handling multi-byte characters.
 * This is a UTF-8 safe replacement for atob().
 */
export function base64ToUtf8(base64: string): string {
  const binary = atob(base64)

  // Convert binary string back to bytes
  const bytes = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i)
  }

  const decoder = new TextDecoder()
  return decoder.decode(bytes)
}
